import React, { useEffect, useState, Fragment } from 'react'
import { Button, Col, Form, OverlayTrigger, Row, Tooltip, Modal, Card} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { useFormik } from 'formik'
import validationSchemas from '../../common/validation-Schemas-Implicado'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { configuracionFormActionImplicado } from '../../store/actions/caso-general-action'
import { isValidParam } from '../../common/Formatos'
import 'recupero-comunes/dist/index.css'
import {
  obtenerComboCompanias,
  obtenerComboSeguro,
  obtenerComboComunas,
  obtenerComboVehiculos,
  obtenerDatosPantalla,
  obtenerGrillaImplicado,
  obtenerComboMarcas,
  obtenerComboPais,
  enviarActualizacionImplicado,
  enviarAdicionarImplicado,
  obtenerParametros,
  obtenerFormulario37,
  obtenerComboDestinatario,
  obtenerComboMedioPago,
  obtenerComboInstitucion,
  obtenerComboTipoCuenta,
  obtenerComboTipoInvolucrado,
  obtenerComboLesionado,
  obtenerComboGestion
} from '../../store/actions/implicado-action'
import ModalPrincipal from './modal'
import { reset_formato_rut } from '../../common/Formatos'

const ImplicadoTerceros = () => {
  const [lista, setLista] = useState([])
  const [show, setShow] = useState(false)
  const [ID, setID] = useState('')
  const [loading, setLoading] = useState(false)
  const [rutConductorFinal, setRutConductorFinal] = useState('')
  const [rutPropietarioFinal, setRutPropietarioFinal] = useState('')
  const [paisImplicadoFinal, setPaisImplicadoFinal] = useState('')
  const [showToast, setShowToast] = useState(false);
  const [reclama, setReclama] = useState(null);
  const [isImplicado, setIsImplicado] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [handleShowProp, setHandleShowProp] = useState(false);

  const [stateChkConductor, setStateChkConductor] = useState(false);
  const [stateChkPropietario, setStateChkPropietario] = useState(false);
  const [ciudadIdImplicado, setIdCiudadImplicado] = useState('')

  const handleCloseToast = () => setShowToast(false)
  const handleShowToast = () => setShowToast(true)
  const { rutUsuario } = Auth.currentUser()
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const data_implicado = useSelector((state) => state.implicadoReducer)
  const { grillaImplicado, comboPais, datosPantalla, datosNoFormatos, rutConductor, rutPropietario, rutDestinatario } = data_implicado
  const { cfg_form, llaves } = data_datos_generales
  const dispatch = useDispatch()
  let pais = 'Chile'

  const handleClose = () => {
    setShow(false);
    formik.resetForm();
  } 
  const handleShowImplicado = (isImplicado, row) => {
    setIsImplicado(isImplicado)
    if (!isImplicado) {
      setID(row.IdImplicado)
    }
    setLoading(true)
    let query = Buffer.from(
      JSON.stringify({ rutcia: llaves['idOrgCaso'], idform: 7 })
    ).toString('base64')
    dispatch(configuracionFormActionImplicado(query))
      .then(() => {

        let query = Buffer.from(JSON.stringify({ concepto: 212 })).toString(
          'base64'
        )
        dispatch(obtenerComboSeguro(query))
      })
      .then(() => {

        let query = Buffer.from(JSON.stringify({ concepto: 260 })).toString(
          'base64'
        )
        dispatch(obtenerComboDestinatario(query))
      })
      .then(() => {

        let query = Buffer.from(JSON.stringify({ concepto: 53 })).toString(
          'base64'
        )
        dispatch(obtenerComboMedioPago(query))
      })
      .then(() => {

        let query = Buffer.from(JSON.stringify({ concepto: 54 })).toString(
          'base64'
        )
        dispatch(obtenerComboTipoCuenta(query))
      })
      .then(() => {

        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idCaso: llaves['idCaso'] })
          ).toString('base64')
          dispatch(obtenerComboInstitucion(query))

        }
      })
      .then(() => {

        let query = Buffer.from(JSON.stringify({ idform: 37, rutcia: llaves && llaves['idOrgCaso'] })).toString(
          'base64'
        )
        dispatch(obtenerFormulario37(query))
      })
      .then(() => {
        //if (!isImplicado) {
          let query = Buffer.from(
            JSON.stringify({
              idImplicado: row ? row.IdImplicado : 100,
              idCaso: llaves && llaves['idCaso']
            })
          ).toString('base64')
          dispatch(obtenerDatosPantalla(query))
        //}
      })
      .then(() => {
        let query = Buffer.from(JSON.stringify({ concepto: 16 })).toString('base64')
        dispatch(obtenerComboVehiculos(query))
      })
      .then(() => {
        let query = Buffer.from(JSON.stringify({ concepto: 18 })).toString('base64')
        dispatch(obtenerComboPais(query))
      })
      .then(() => {
        let query = Buffer.from(JSON.stringify({ concepto: 205 })).toString('base64')
        dispatch(obtenerComboTipoInvolucrado(query))
      })
      .then(() => {
        let query = Buffer.from(JSON.stringify({ concepto: 203 })).toString('base64')
        dispatch(obtenerComboLesionado(query))
      })
      .then(() => {
        let query = Buffer.from(JSON.stringify({ concepto: 207 })).toString('base64')
        dispatch(obtenerComboGestion(query))
      })
      .then(() => {
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ rutCia: llaves['idOrgCaso'], parametro: 45 })
          ).toString('base64')
          dispatch(obtenerComboComunas(query))
        }
      })
      .then(() => {
        if (llaves) {
          let query = Buffer.from(
            JSON.stringify({ idOrgCaso: llaves['idOrgCaso'] })
          ).toString('base64')
          dispatch(obtenerComboMarcas(query))
        }
      })
      .then(() => {
        let query = Buffer.from(JSON.stringify({})).toString('base64')
        dispatch(obtenerComboCompanias(query))
      })
      .then(() => {
        let query = Buffer.from(JSON.stringify({ "rutcia": 0, "parametro": 34 })).toString('base64')
        dispatch(obtenerParametros(query))
      })
      .then(() => setLoading(false))
    setShow(true)
    setHandleShowProp(true);
  }




  useEffect(() => {
    setLista(grillaImplicado && grillaImplicado.grillaImplicado)
  }, [grillaImplicado])



  const obtenerColumnas = () => {
    return [
      {
        dataField: 'IdImplicado',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-id'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'NombreImplicado',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-nomrazsoc'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: (colum, colIndex) => {
          return {
            width: '15%',
            textAlign: 'center',
            verticalAlign: 'middle',
            backgroundColor: '#728bb0',
            color: 'white'
          }
        }
      },
      {
        dataField: 'GlosaBienImplicado',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-tipovh'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'PlacaPatente',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-patente'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'TipoGestion',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-tipogestion'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'EstadoCaso',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-estado'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'FechaEstadoFormat',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-fecestado'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'SeguroImplicado',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-seguro'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'CiaImplicado',
        text: cfg_form ? cfg_form.cfg_form[
          'casograldefensa-grillaimpl-cia'
        ] : '',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'opciones',
        text: '',
        isDummyField: true,
        headerStyle: (colum, colIndex) => {
          return {
            width: '40%',
            textAlign: 'center',
            verticalAlign: 'center',
            backgroundColor: '#728bb0',
            color: 'white'
          }
        },
        style: { textAlign: 'center', verticalAlign: 'middle' },
        formatter: (cell, row) => (
          <div>
            <OverlayTrigger
              overlay={<Tooltip id='tooltip-disabled'>Detalles </Tooltip>}
            >
              <Button
                type='button'
                variant='opciones me-md-2'
                size='sm'
                onClick={() => handleShowImplicado(false, row)}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='16'
                  height='16'
                  fill='currentColor'
                  className='bi bi-gear-fill'
                  viewBox='0 0 16 16'
                >
                  <path d='M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z' />
                </svg>
              </Button>
            </OverlayTrigger>
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      }
    ]
  }
  const formik = useFormik({
    initialValues: {
      idCaso: '',
      idImplicado: '',
      tipoVehiculo: '',
      seguro: '',
      idCompania: '',
      idSiniestroIM: '',
      fechaSiniestroIM: '',
      patente: '',
      marcaVehiculo: '',
      detalleDescripcion: ''
    },
    validationSchema: validationSchemas(pais, paisImplicadoFinal, isImplicado),
    onSubmit: (formData) => {
      const rutImplicado =
        datosNoFormatos &&
        datosNoFormatos.substring(0, datosNoFormatos.length - 1)
      const dvRutImplicado =
        datosNoFormatos &&
        datosNoFormatos.substring(
          datosNoFormatos.length - 1,
          datosNoFormatos.length
        )

      const rutConductor1 = rutConductor && rutConductor !== "" ? rutConductor.substring(0, rutConductor.length - 1) : "19".substring(0, "19".length - 1)
      const dvRutConductor = rutConductor && rutConductor !== "" ?
        rutConductor.substring(rutConductor.length - 1, rutConductor.length) :
        "19".substring("19".length - 1, "19".length)

      const rutPropietario1 = rutPropietario && rutPropietario !== "" ? rutPropietario.substring(0, rutPropietario.length - 1) : "19".substring(0, "19".length - 1)
      const dvRutPropietario = rutPropietario && rutPropietario !== "" ?
        rutPropietario.substring(rutPropietario.length - 1, rutPropietario.length) :
        "19".substring("19".length - 1, "19".length)

      const rutDestinatario1 = rutDestinatario && rutDestinatario.substring(0, rutDestinatario.length - 1)

      const dvRutDestinatario =
        rutDestinatario &&
        rutDestinatario.substring(
          rutDestinatario.length - 1,
          rutDestinatario.length
        )
      const data = {
        terceroImplicado: {},
        implicado: {},
        propietario: {},
        conductorIM: {},
        destinatarioPago: {},
      }
      const dataForm = { ...formData }
      let regexRutTercero = "";
      let dvRut = "";

      if (isImplicado) {
        const rut = dataForm['rutImplicadoTercero'];
        dvRut = rut.substring(rut.length - 1, rut.length);
        regexRutTercero = reset_formato_rut(rut.substring(0, rut.length - 1))

        data.terceroImplicado['rut'] = regexRutTercero;
        data.terceroImplicado['nombre'] = dataForm['nombreInvolucradoTercero'];
        data.terceroImplicado['gestion'] = dataForm['gestion'];
        data.terceroImplicado['idOrganizacion'] = llaves['idOrgCaso'];
        data.terceroImplicado['dvRut'] = dvRut;
      }
      data.terceroImplicado['idUsuario'] = rutUsuario;
      data.terceroImplicado[isImplicado ? 'tipoVehiculoIM' : 'tipoVehiculo'] = dataForm['tipoVehiculo']
      data.terceroImplicado['tipoInvolucrado'] = dataForm['tipoInvolucrado']
      data.terceroImplicado['implLesionado'] = dataForm['lesionado']
      data.terceroImplicado['reclamacion'] = reclama && reclama
      data.terceroImplicado['idCaso'] = llaves && llaves['idCaso']
      data.terceroImplicado['idImplicado'] = ID
      data.terceroImplicado[isImplicado ? 'seguroIM' : 'seguro'] = dataForm['seguro']
      data.terceroImplicado['idCompania'] = dataForm['idCompania']
      data.terceroImplicado['idSiniestroIM'] = dataForm['idSiniestroIM']
      data.terceroImplicado['fechaSiniestroIM'] = dataForm['fechaSiniestroIM']
      data.terceroImplicado[isImplicado ? 'patenteIM' : 'patente'] = dataForm['patente']
      data.terceroImplicado[isImplicado ? 'marcaVehiculoIM' : 'marcaVehiculo'] = dataForm['marcaVehiculo']
      data.terceroImplicado['detalleDescripcion'] =
        dataForm['detalleDescripcion']
      data.implicado['rut'] = isImplicado ? regexRutTercero : (rutImplicado && rutImplicado[rutImplicado.length - 1] === "-" ? rutImplicado.substring(0, rutImplicado.length - 1) : rutImplicado)
      data.implicado['dvRut'] = isImplicado ? dvRut : (dvRutImplicado && dvRutImplicado)
      data.implicado['nombre'] = isImplicado ? dataForm['nombreInvolucradoTercero'] : dataForm['nombreImplicado'];
      data.implicado['direccion'] = dataForm['direccionImplicado']
      data.implicado['email'] = dataForm['emailImplicado']
      data.implicado['paisFono'] = comboPais && dataForm['paisImplicado'] !== '' ? comboPais.comboPais?.find(c => c.id === parseInt(dataForm['paisImplicado']))?.nombre : ''
      data.implicado['paisMovil'] = comboPais && comboPais.comboPais?.find(c => c.id === parseInt(dataForm['paisMovilImplicado']))?.nombre
      data.implicado['fono'] = dataForm['fonoImplicado']
      data.implicado['movil'] = dataForm['movilImplicado']
      data.implicado['comuna'] = dataForm['comunaImplicado']
      data.implicado['ciudadImplicado'] = ciudadIdImplicado
      data.implicado['idInvolucrado'] = (datosPantalla && datosPantalla.datosPantalla[0] && isValidParam(datosPantalla.datosPantalla[0]['IdInvolucradoImp'])) ? datosPantalla?.datosPantalla[0]['IdInvolucradoImp'] : 1
      data.conductorIM['rut'] = rutConductor1 && rutConductor1[rutConductor1.length - 1] === "-" ? rutConductor1.substring(0, rutConductor1.length - 1) : rutConductor1
      data.conductorIM['dvRut'] = dvRutConductor && dvRutConductor
      data.conductorIM['nombre'] = dataForm['nombreConductor'] !== "" ? dataForm['nombreConductor'] : "NO INFORMADO"
      data.conductorIM['direccion'] = dataForm['direccionConductor']
      data.conductorIM['email'] = dataForm['emailConductor']
      data.conductorIM['paisFono'] = comboPais && comboPais.comboPais?.find(c => c.id === parseInt(dataForm['paisConductor']))?.nombre
      data.conductorIM['paisMovil'] = comboPais && comboPais.comboPais?.find(c => c.id === parseInt(dataForm['paisMovilConductor']))?.nombre
      data.conductorIM['fono'] = dataForm['fonoConductor']
      data.conductorIM['movil'] = dataForm['movilConductor']
      data.conductorIM['comuna'] = dataForm['comunaConductor']
      data.conductorIM['idInvolucrado'] = (datosPantalla && datosPantalla.datosPantalla[0] && isValidParam(datosPantalla.datosPantalla[0]['IdInvolucradoCond'])) ? datosPantalla.datosPantalla[0]['IdInvolucradoCond'] : 3
      data.propietario['rut'] = rutPropietario1 && rutPropietario1[rutPropietario1.length - 1] === "-" ? rutPropietario1.substring(0, rutPropietario1.length - 1) : rutPropietario1
      data.propietario['dvRut'] = dvRutPropietario && dvRutPropietario
      data.propietario['nombre'] = dataForm['nombrePropietario'] !== "" ? dataForm['nombrePropietario'] : "NO INFORMADO"
      data.propietario['direccion'] = dataForm['direccionPropietario']
      data.propietario['email'] = dataForm['emailPropietario']
      data.propietario['paisFono'] = comboPais && comboPais.comboPais?.find(c => c.id === parseInt(dataForm['paisPropietario']))?.nombre
      data.propietario['fono'] = dataForm['fonoPropietario']
      data.propietario['movil'] = dataForm['movilPropietario']
      data.propietario['comuna'] = dataForm['comunaPropietario']
      data.propietario['paisMovil'] = comboPais && comboPais.comboPais?.find(c => c.id === parseInt(dataForm['paisMovilPropietario']))?.nombre
      data.propietario['idInvolucrado'] = ID
      data.propietario['idInvolucrado'] = (datosPantalla && datosPantalla.datosPantalla[0] && isValidParam(datosPantalla.datosPantalla[0]['IdInvolucradoProp'])) ? datosPantalla.datosPantalla[0]['IdInvolucradoProp'] : 2
      
      data.destinatarioPago['tipoDestinatario'] = dataForm['tipoDestinatario']
      
      data.destinatarioPago['rut'] = dataForm['tipoDestinatario'] !== "260001" ? 
        (rutDestinatario1 && rutDestinatario1[rutDestinatario1.length - 1] === "-" ? rutDestinatario1.substring(0, rutDestinatario1.length - 1) : rutDestinatario1) :
        (isImplicado ? regexRutTercero : (rutImplicado && rutImplicado[rutImplicado.length - 1] === "-" ? rutImplicado.substring(0, rutImplicado.length - 1) : rutImplicado))
      
      data.destinatarioPago['dvRut'] = dataForm['tipoDestinatario'] !== "260001" ? 
        	dvRutDestinatario && dvRutDestinatario : 
          isImplicado ? dvRut : (dvRutImplicado && dvRutImplicado)
      
      data.destinatarioPago['nombre'] = dataForm['tipoDestinatario'] !== "260001" ? dataForm['nombreDestinatario'] : data.implicado['nombre']
      data.destinatarioPago['email'] = dataForm['tipoDestinatario'] !== "260001" ? dataForm['emailDestinatario'] : data.implicado['email']
      data.destinatarioPago['medioPago'] = dataForm['medioPago']
      data.destinatarioPago['institucionFinanciera'] = dataForm['institucion']
      data.destinatarioPago['tipoCuenta'] = dataForm['tipoCuenta']
      data.destinatarioPago['numeroCuenta'] = dataForm['numeroCuenta']

      const isValid = validateDestinatario(data.destinatarioPago);

      //console.log("dataForm", dataForm);
      //console.log("Form.esConductor:", stateChkConductor);
      //console.log("Form.esPropietario:", stateChkPropietario);

      data.terceroImplicado['esConductor'] = stateChkConductor;
      data.terceroImplicado['esPropietario'] = stateChkPropietario;

      //console.log("data", data);

      //return false;

      if (isValid) {
        setLoading(true)
        dispatch(isImplicado ? enviarAdicionarImplicado(data) : enviarActualizacionImplicado(data)).then(() => {
          
          if (llaves) {
            let query = Buffer.from(
              JSON.stringify({
                idOrgCaso: llaves['idOrgCaso'],
                idCaso: llaves['idCaso']
              })
            ).toString('base64')            
            dispatch(obtenerGrillaImplicado(query))
            .then(() => {
              setLoading(false)
            });
          } else {
            setLoading(false)
          }
        })
        handleShowToast()        
      } else {
        setShowModal(true);
      }
    }
  })

  const validateDestinatario = (data) => {
    let valid = false;

    if (data.tipoDestinatario === "" && (data.rut === "" || data.rut == 0) && data.nombre === "" && data.email === "" && data.medioPago === "" && data.institucionFinanciera === "" && data.tipoCuenta === "" && data.numeroCuenta === "")
      valid = true;
    else if (data.tipoDestinatario !== "" && data.rut !== "" && data.nombre !== "" && data.medioPago !== "" && data.institucionFinanciera !== "" && data.tipoCuenta !== "" && data.numeroCuenta !== "")
      valid = true;
    else
      valid = false;

    return valid;
  }

  return (
    <>
      <div>
        {/* <LoadingComponent show={loading}/> */}
        <style type='text/css'>
          {`
        .btn-opciones {
          background-color: #00aeab;
          color: #FFFFFF;
        }
        .btn-opciones:hover{
          background-color: #58c4c2;
          color: #FFFFFF;
        }
        .btn-carpeta:hover{
            background-color:#01ceca;
            color: #FFFFFF;
        }
        .btn-actualizar {
          background-color: #C14B49;
          color: #FFFFFF;
          width: 140px;
          padding:6px 0px 6px 0px;

        }
        .btn-actualizar:hover{
            background-color: #d3807f;
          color: #FFFFFF;
        }
     `}
        </style>
        <LoadingComponent show={loading} />
        <Modal show={show} onHide={handleClose} size='xl'>
          <Form onSubmit={formik.handleSubmit}>
            <ModalPrincipal
              ID={ID}
              formik={formik}
              setReclama={setReclama}
              setRutConductorFinal={setRutConductorFinal}
              setRutPropietarioFinal={setRutPropietarioFinal}
              setPaisImplicadoFinal={setPaisImplicadoFinal}
              setShowToast={setShowToast}
              showToast={showToast}
              isImplicado={isImplicado}
              handleShowProp={handleShowProp}
              setHandleShowProp={setHandleShowProp}
              handleClose={handleClose}
              stateChkConductor={stateChkConductor}
              setStateChkConductor={setStateChkConductor}
              stateChkPropietario={stateChkPropietario}
              setStateChkPropietario={setStateChkPropietario}
              setIdCiudadImplicado={setIdCiudadImplicado}
            />
            <Modal.Footer>
              <Button variant='outline-info' onClick={handleClose}>
                Volver
              </Button>
              <Button variant='actualizar' type='onSubmit'>
                {isImplicado ? 'Adicionar' : 'Actualizar'}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
        {cfg_form ? (
          <>
            <ToolkitProvider
              style={{ position: 'relative', zIndex: '-1' }}
              search
              bootstrap4
              keyField='IdImplicado'
              data={lista ? lista : []}
              columns={obtenerColumnas()}
              defaultSorted={[{ dataField: 'FechaEstadoFormat', order: 'asc' }]}
            >
              {(props) => (
                <div>
                  <div
                    className='rounded mb-0'
                    style={{ backgroundColor: '#D1F2EB', color: '#4F517A' }}
                  >
                    <h6 className='p-2'>{`${cfg_form.cfg_form['casograldefensa-grillaimpl-title']} `}</h6>
                  </div>

                  <BootstrapTable
                    style={{ position: 'relative', zIndex: '-100000000000000000' }}
                    {...props.baseProps}
                    bordered={false}
                    headerWrapperClasses='table-secondary'

                    noDataIndication={
                      <div className='text-center'>
                        No hay registros encontrados
                      </div>
                    }
                  />
                </div>
              )}
            </ToolkitProvider>

            <Row>
              <Col className='d-flex align-items-end justify-content-end '>
                <Button className='mx-2 w-auto' variant='opciones' onClick={() => handleShowImplicado(true)} >
                  {cfg_form && cfg_form.cfg_form["casograldefensa-btn-nvoimpl"]}
                  {/*Ingresar nuevo tercero*/}
                </Button>
              </Col>
            </Row>
          </>
        ) : null}

      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
        <Card>
          <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
            Información
          </Card.Header>

          <Card.Body>
            La información destinatario de pago es opcional, pero si se agrega algún dato se debe completar el formulario.
          </Card.Body>

          <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
            <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModal(false)}>Cerrar</Button>
          </Card.Footer>
        </Card>
      </Modal>
    </>
  )
}

export default ImplicadoTerceros
